import classNames from "classnames/bind";
import type { NewsletterFormProps } from "features/home/components/NewsletterForm";
import NewsletterForm from "features/home/components/NewsletterForm";
import styles from "./NewsletterSignUp.module.scss";

const cx = classNames.bind(styles);

export interface NewsletterSignUpProps extends NewsletterFormProps {
    className?: string;
}

const NewsletterSignUp = (props: NewsletterSignUpProps) => {
    const { title, text, className, ...rest } = props;

    return (
        <div className={cx("content", className)}>
            <div className={cx("head")}>
                <h2 className={cx("heading")}>{title}</h2>
                {text && <p className={cx("subHeading")}>{text}</p>}
            </div>
            <NewsletterForm {...rest} />
        </div>
    );
};

export default NewsletterSignUp;
